import framework from '@/enums/enum-framework'

const enumsName = 'planPhaseGrade'

const enums = [
  {
    value: '大一',
    label: '大一'
  },
  {
    value: '大二',
    label: '大二'
  },
  {
    value: '大三',
    label: '大三'
  },
  {
    value: '大四',
    label: '大四'
  },
  {
    value: '大五',
    label: '大五'
  },
  {
    value: '研一',
    label: '研一'
  },
  {
    value: '研二',
    label: '研二'
  },
  {
    value: '研三',
    label: '研三'
  },
  {
    value: '已毕业',
    label: '已毕业'
  },
  {
    value: '延毕',
    label: '延毕'
  },
  {
    value: 'Gap Year',
    label: 'Gap Year'
  }
]

const map = framework.convert2Map(enums)

const filter = framework.convert2Filter(map)

const obj = {}
obj[enumsName + 'Enum'] = enums
obj[enumsName + 'Map'] = map
obj[enumsName + 'Filter'] = filter

export default obj
